import ScrollMagic from 'scrollmagic';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import ieScrollFix from 'utils/ie-scroll-fix';

class Scrollers {
  constructor(container, items, itemContainer) {
    this.container = container;
    this.items = items;
    this.itemContainer = itemContainer;

    this.itemDuration = 500;
    ieScrollFix();
    this.bindScrollMagic();
  }

  bindScrollMagic = () => {
    const controller = new ScrollMagic.Controller();

    Array.forEach(this.items, (s, index) => {
      const scrollItemScene = new ScrollMagic.Scene({
        triggerElement: s,
        triggerHook: window.matchMedia('(max-width: 991px)').matches ? 0.6 : 0.5,
        duration: index === this.items.length ? 0 : this.itemDuration,
        reverse: true,
      });

      // scrollItemScene.addIndicators({ name: 'Items' });
      // if ((index + 1) < this.items.length) {
      //   scrollItemScene.setPin(s);
      // }

      scrollItemScene.setClassToggle(s, 'active');
      // scrollItemScene.on('end', (e) => {
      //   if (e.scrollDirection === 'FORWARD' && (index + 1) === this.items.length) {
      //     s.classList.add('dont-fade-out');
      //   } else {
      //     s.classList.add('dont-fade-out');
      //   }
      // });
      // scrollItemScene.on('start', (e) => {
      //   if (e.scrollDirection === 'REVERSE') {
      //     s.classList.remove('fade-out');
      //     s.classList.remove('end-active');
      //   }
      // });
      scrollItemScene.addTo(controller);
    });

    const containerScene = new ScrollMagic.Scene({
      triggerElement: this.container,
      offset: -119,
      triggerHook: 0,
      duration: this.getDuration(),
    });
    // containerScene.setPin(this.container);
    // containerScene.addIndicators({ name: 'Container' });

    containerScene.addTo(controller);
  }

  getDuration = () => {
    let height = 0;

    for (let index = 0; index < this.items.length - 1; index += 1) {
      const item = this.items[index];
      height += (item.offsetHeight + this.itemDuration + 60);
    }

    return height;
  }
}


const items = document.querySelectorAll('.js-he-scroll-item');
const itemContainer = document.querySelector('.js-he-scroll-items-container');
const container = document.querySelector('.js-he-scrollers');

if (container !== null && items !== null && items.length > 0 && itemContainer !== null) {
  // eslint-disable-next-line
  new Scrollers(container, items, itemContainer);
}

